import { useEffect, useState } from "react"
import { EditScoreProfile } from "./EditScoreProfile"

import aiGreen from '../../../custom_assets/testScoreStrategy/ai_green.png'
import aiGray from '../../../custom_assets/testScoreStrategy/ai_gray.png'
import aiYellow from '../../../custom_assets/testScoreStrategy/ai_yellow.png'
import aiRed from '../../../custom_assets/testScoreStrategy/ai_red.png'

import greenCheckmark from '../../../custom_assets/testScoreStrategy/green_checkmark.png'
import redCaution from '../../../custom_assets/testScoreStrategy/red_caution.png'
import yellowLine from '../../../custom_assets/testScoreStrategy/yellow_line.png'

const AggregateRecommendation = ({ userSATScoreOutput, userACTScoreOutput, res, userSATSuperScore, userACTBestScore, user, setFormValues, inOverlay = false }) => {

  const [result, setResult] = useState<any>(6)

  useEffect(() => {

    const recommendationLogic = (userSATScoreOutput, userACTScoreOutput, res) => {

      if (res.testPolicy == 3) {
        // Do not submit
        return setResult(5)
      }

      // CTA to enter score data
      if (userSATScoreOutput === -1 && userACTScoreOutput === -1) {
        return setResult(7)
      }

      // Insufficient college data
      if (userSATScoreOutput === -2 && userACTScoreOutput === -2) {
        return setResult(6)
      }

      if (userSATScoreOutput === -2 && userACTScoreOutput === -1) {
        return setResult(6)
      }

      if (userSATScoreOutput === -1 && userACTScoreOutput === -2) {
        return setResult(6)
      }

      // Testpolicy 1 vs 2:
      switch (true) {
        case res.testPolicy == 1:
          if (userSATScoreOutput > userACTScoreOutput) {
            //Submit SAT
            return setResult(2)
          }
          else if (userSATScoreOutput < userACTScoreOutput) {
            //Submit ACT
            return setResult(3)
          }
          else {
            //Submit either
            return setResult(1)
          }
        case res.testPolicy == 2:
          if (userSATScoreOutput > userACTScoreOutput) {
            if (userSATScoreOutput >= 60) {
              //Submit SAT
              return setResult(2)
            }
            else if ((40 <= userSATScoreOutput) && (userSATScoreOutput < 60)) {
              //Borderline
              return setResult(4)
            }
            else if (userSATScoreOutput < 40) {
              // Do not submit
              return setResult(5)
            }
          }

          if (userSATScoreOutput < userACTScoreOutput) {
            if (userACTScoreOutput >= 60) {
              // Submit ACT 
              return setResult(3)
            }
            else if ((40 <= userACTScoreOutput) && (userACTScoreOutput < 60)) {
              // Borderline
              return setResult(4)
            }
            else if (userACTScoreOutput < 40) {
              //Do not submit
              return setResult(5)
            }
          }

          if (userSATScoreOutput === userACTScoreOutput) {
            if (userSATScoreOutput >= 60) {
              if (res.college_cds[0].submitSATPercent >= res.college_cds[0].submitACTPercent) {
                // Submit SAT
                return setResult(2)
              }
              else if (res.college_cds[0].submitSATPercent < res.college_cds[0].submitACTPercent) {
                // Submit ACT
                return setResult(3)
              }
            }
            if (40 <= userSATScoreOutput && userSATScoreOutput < 60) {
              //Borderline
              return setResult(4)
            }
            if (userSATScoreOutput < 40) {
              // Do not submit
              return setResult(5)
            }
          }
      }
    }

    recommendationLogic(userSATScoreOutput, userACTScoreOutput, res)

  }, [userSATSuperScore, userACTBestScore, res])

  const submitSATandACT = (
    <div>Submit SAT & ACT Scores</div>
  )
  const submitSAT = (
    <div>Submit SAT Score</div>
  )
  const submitACT = (
    <div>Submit ACT Score</div>
  )
  const borderline = (
    <div>Borderline</div>
  )
  const doNotSubmit = (
    <div>Do not submit</div>
  )
  const insufficient = (
    <div>Insufficient College Data</div>
  )

  const returnAggregate = (result) => {
    switch (true) {
      case result === 5:
        return doNotSubmit
      case result === 1:
        return submitSATandACT
      case result === 2:
        return submitSAT
      case result === 3:
        return submitACT
      case result === 4:
        return borderline
      case result === 6:
        return insufficient
      case result === 7:
        return <EditScoreProfile
          user={user}
          setFormValues={setFormValues}
          pill={true}
        />
      default:
        return insufficient
    }
  }

  const returnColor = (result) => {
    switch (result) {
      // Submit SAT and ACT
      case 1:
        return 'rgba(213, 251, 171, 0.65)'
      // Submit SAT 
      case 2:
        return 'rgba(152, 242, 155, 0.34)'
      case 3:
        //  Submit ACT
        return 'rgba(0, 226, 130, 0.23)'
      // Borderline
      case 4:
        return 'rgba(255, 253, 231, 1)'
      // Do not submit
      case 5:
        return 'rgba(255, 240, 240, 1)'
      // Insufficient
      case 6:
        return 'rgba(184, 184, 184, 0.11)'
      // Edit score profile
      case 7:
        return 'rgba(184, 184, 184, 0.11)'
      default:
        return 'rgba(184, 184, 184, 0.11)'
    }
  }

  const returnIcon = (result) => {
    switch (result) {
      // Submit SAT and ACT
      case 1:
        return [aiGreen, 'green']
      // Submit SAT 
      case 2:
        return [aiGreen, 'green']
      //  Submit ACT
      case 3:
        return [aiGreen, 'green']
      // Borderline
      case 4:
        return [aiYellow, 'yellow']
      // Do not submit
      case 5:
        return [aiRed, 'red']
      // Insufficient
      case 6:
        return [aiGray, 'gray']
      default:
        return []
    }
  }

  const returnConditionalIcon = (result, satScore, actScore) => {

    if (![1, 2, 3].includes(result)) return <></>

    let iconMap: any = {
      green: {
        src: greenCheckmark,
        alt: 'greenCheckmark',
        class: 'dca-conditional-icon-testScoreStrategy-green'
      },
      yellow: {
        src: yellowLine,
        alt: 'yellowLine',
        class: 'dca-conditional-icon-testScoreStrategy-yellow'
      },
      red: {
        src: redCaution,
        alt: 'redCaution',
        class: 'dca-conditional-icon-testScoreStrategy-red'
      }
    }

    // Check score, return null if negative, otherwise 
    const getScoreCategory = (score: number): 'green' | 'yellow' | 'red' | null => {
      if (score < 0) return null;
      if (score > 60) return 'green';
      if (score < 40) return 'red';
      return 'yellow';
    };

    const satCategory = getScoreCategory(satScore);
    const actCategory = getScoreCategory(actScore);

    if (satCategory === 'green' || actCategory === 'green') {
      return <img src={iconMap.green.src} alt={iconMap.green.alt} className={iconMap.green.class}></img>
    } else if (satCategory === 'yellow' || actCategory === 'yellow') {
      return <img src={iconMap.yellow.src} alt={iconMap.yellow.alt} className={iconMap.yellow.class}></img>
    } else if (satCategory === 'red' || actCategory === 'red') {
      return <img src={iconMap.red.src} alt={iconMap.red.alt} className={iconMap.red.class}></img>
    }

  }

  // const showExtraDetails = (
  //   <div>Test Policy: {res.testPolicy} Result: {result} SAT Score Output {userSATScoreOutput} ACT Score Output {userACTScoreOutput}</div>
  // )

  // return (
  //   <div
  //     className='d-flex justify-content-center align-items-center align-self-center fw-bold rounded'
  //     style={{ backgroundColor: returnColor(result), height: '31px', display: 'inline-block', padding: '10px' }}
  //   > {returnAggregate(result)}
  //   </div>
  // )

  return (
    <div
      className={result === 7 ? `` : `dca-test-score-modal-recommendation-pill`}
      style={{
        backgroundColor: result === 7 ? '' : returnColor(result),
        color: inOverlay ? 'inherit' : '',
        textDecoration: inOverlay ? 'none' : 'underline'
      }}
    >{result != 7 && <img src={returnIcon(result)[0]} alt={`ai_icon_${returnIcon(result)[1]}`} className="dca-test-score-modal-recommendation-pill-ai-icon"></img>} {returnAggregate(result)} {returnConditionalIcon(result, userSATScoreOutput, userACTScoreOutput)}
    </div>
  )
}

export { AggregateRecommendation }


